import { createAction } from 'redux-act';

import Employee from '../../../../models/interfaces/Employee';
import CompanyPayload from './CompanyPayload';

export interface InviteEmployeesPayload extends CompanyPayload {
  invitations: { userUuid: string; email: string }[];
}
export const inviteEmployees = createAction<InviteEmployeesPayload>('INVITE_EMPLOYEES');

export interface EmployeesInvitedPayload extends CompanyPayload {
  employees: Employee[];
}
export const employeesInvited = createAction<EmployeesInvitedPayload>('EMPLOYEES_INVITED');

export interface EmployeesInviteFailedPayload extends CompanyPayload {
  invitations: { userUuid: string; email: string }[];
}
export const employeesInviteFailed = createAction<EmployeesInviteFailedPayload>('EMPLOYEES_INVITE_FAILED');
